import React from "react";
import PricingTable from "./pricingTable";
import FaqSection from "./Accordion/Accordion";

function Pricing() {
     const FAQData = [
         {
      question: "Store client and prospect information",
      answer:
        "Gather valuable insights about your clients and leverage that data to serve them better. With a top-tier CRM solution for small businesses, you can centralize all client and prospect information in a single hub, significantly enhancing the efficiency and effectiveness of your client servicing.",
    },
    {
      question: "Simplified account management",
      answer:
        "Consolidate your company's leads and clients on a unified dashboard. Configure your CRM hub with client-centric workflows, unlimited contacts, custom fields, tags, filters, and bulk actions. Our AI-powered platform helps you establish clear links between contacts and accounts to build and track relationships seamlessly.",
    },
    {
      question: "End-to-end management control",
      answer:
        "TrackmyDoc is your single point of control for organizing and automating accounting, payroll, and bookkeeping processes. Manage client communication, the intake process, task creation, scheduling, billing, engagement letters, and custom CRM templates—all executed swiftly and flawlessly with minimal intervention required.",
    },
    {
      question: "Onboard clients in a snap",
      answer:
        "Use our powerful CRM software to save your team time and serve more clients efficiently. AI-powered automation facilitates smooth new client onboarding. From capturing a lead via a personalized login page to e-signing completed files, we make the entire process simple and quick.",
    },
    {
      question: "Automated reminders",
      answer:
        "Automate reminders to keep your clients on track without manual intervention. Eliminate tedious follow-ups; instead, use automation to promptly notify clients about pending organizers, invoices, contracts, messages, approvals, signatures, and file requests. This integrated approach, featuring e-signature software, billing solutions, and recurring invoicing, saves hours of manual work while boosting client engagement.",
    },
     ]
     return (
          <div className="py-[65px]">
               <div className="website-container">
                    <div className="text-center">
                         <h1 className="text-[#000] text-[40px] text-center max-[425px]:text-[20px]">
                              <span className="text-[#0BAFD4]">⚡ Limited Time Offer</span><br /> First 25 Clients Get 50% OFF!
                         </h1>
                         <p className="text-[18px]">
                              With no complicated tiers, modules, or fees per contact, you can feel
                              <br /> confident you made the right choice.
                         </p>
                    </div>
               </div>

               <PricingTable />

               <FaqSection data={FAQData} subTitle='Your concerns, answered' Title='Frequently asked questions' />
          </div>
     );
}

export default Pricing;
